import {
  CAPTCHA,
  LOADING_CAPTCHA,
  LOGIN,
  LOADING_LOGIN,
  LOGOUT,
  LOADING_LOGOUT,
  VALIDATE_TOKEN_BSS,
  LOADING_VALIDATE_TOKEN_BSS,
  TERM_AND_CONDITION,
  LOADING_TERM_AND_CONDITION,
  MENU_LIST,
  LOADING_MENU_LIST,
  VALIDATE_TOKEN_BRISPOT,
  LOADING_VALIDATE_TOKEN_BRISPOT,
  HEADLINE,
  LOADING_HEADLINE,
  LIST_LAYANAN,
  LOADING_LIST_LAYANAN,
  LIST_PRODUK,
  LOADING_LIST_PRODUK,
  CALL_TO_ACTION,
  LOADING_CALL_TO_ACTION,
  LIST_WORD_STYLING,
  LOADING_LIST_WORD_STYLING,
} from "../constants/login";

const initialState = {
  captchaContent: [],
  captchaLoading: true,
  loginDatas: [],
  loginLoading: false,
  logoutDatas: [],
  logoutLoading: true,
  validateBSSDatas: [],
  validateBRISPOTDatas: [],
  isLoadingValidateBSSDatas: true,
  isLoadingValidateBRISPOTDatas: true,
  termCondition: [],
  termConditionLoading: true,
  menuListData: {},
  isLoadingMenuList: true,
  listWordStyling: [],
  isLoadingListWordStyling: true,
  headline: [],
  isLoadingHeadline: true,
  listLayanan: [],
  isLoadingListLayanan: true,
  listProduk: [],
  isLoadingListProduk: true,
  callToAction: [],
  isLoadingCallToAction: true,
};

export default function reducer(
  state = initialState,
  action = {
    type: "",
    captchaContent: [],
    loginDatas: [],
    logoutDatas: [],
    validateBSSDatas: [],
    validateBRISPOTDatas: [],
    termCondition: [],
    menuListData: [],
    listWordStyling: [],
    headline: [],
    listLayanan: [],
    listProduk: [],
    callToAction: [],
  }
) {
  const {
    type,
    captchaContent,
    loginDatas,
    logoutDatas,
    validateBSSDatas,
    termCondition,
    menuListData,
    validateBRISPOTDatas,
    listWordStyling,
    headline,
    listLayanan,
    listProduk,
    callToAction,
  } = action;
  switch (type) {
    case CAPTCHA:
      return {
        ...state,
        captchaContent: captchaContent,
        captchaLoading: false,
      };
    case LOADING_CAPTCHA:
      return {
        ...state,
        captchaLoading: true,
      };
    case LOGIN:
      return {
        ...state,
        loginDatas,
        loadingLogin: false,
      };
    case LOADING_LOGIN:
      return {
        ...state,
        loadingLogin: true,
      };
    case LOGOUT:
      return {
        ...state,
        loginDatas: [],
        logoutDatas,
        loadingLogout: false,
      };
    case LOADING_LOGOUT:
      return {
        ...state,
        loadingLogout: true,
      };
    case VALIDATE_TOKEN_BSS:
      return {
        ...state,
        validateBSSDatas,
        isLoadingValidateBSSDatas: false,
      };
    case LOADING_VALIDATE_TOKEN_BSS:
      return {
        ...state,
        isLoadingValidateBSSDatas: true,
      };
    case VALIDATE_TOKEN_BRISPOT:
      return {
        ...state,
        validateBRISPOTDatas,
        isLoadingvalidateBRISPOTDatas: false,
      };
    case LOADING_VALIDATE_TOKEN_BRISPOT:
      return {
        ...state,
        isLoadingvalidateBRISPOTDatas: true,
      };
    case TERM_AND_CONDITION:
      return {
        ...state,
        termCondition,
        termConditionLoading: false,
      };
    case LOADING_TERM_AND_CONDITION:
      return {
        ...state,
        termConditionLoading: true,
      };
    case MENU_LIST:
      return {
        ...state,
        menuListData,
        isLoadingMenuList: false,
      };
    case LOADING_MENU_LIST:
      return {
        ...state,
        isLoadingMenuList: true,
      };
    case LIST_WORD_STYLING:
      return {
        ...state,
        listWordStyling,
        isLoadingListWordStyling: false,
      };
    case LOADING_LIST_WORD_STYLING:
      return {
        ...state,
        isLoadingListWordStyling: true,
      };
    case HEADLINE:
      return {
        ...state,
        headline,
        isLoadingHeadline: false,
      };
    case LOADING_HEADLINE:
      return {
        ...state,
        isLoadingHeadline: true,
      };
    case LIST_LAYANAN:
      return {
        ...state,
        listLayanan,
        isLoadingListLayanan: false,
      };
    case LOADING_LIST_LAYANAN:
      return {
        ...state,
        isLoadingListLayanan: true,
      };
    case LIST_PRODUK:
      return {
        ...state,
        listProduk,
        isLoadingListProduk: false,
      };
    case LOADING_LIST_PRODUK:
      return {
        ...state,
        isLoadingListProduk: true,
      };
    case CALL_TO_ACTION:
      return {
        ...state,
        callToAction,
        isLoadingCallToAction: false,
      };
    case LOADING_CALL_TO_ACTION:
      return {
        ...state,
        isLoadingCallToAction: true,
      };
  
    default:
      return state;
  }
}
